import ActionTypes from 'core/actions/actionTypes';
import initialState from 'core/reducers/initialState';

/**
 * @overview: Reducer to operate on site layout in the store. Layout is a list
 * of panel instances ids that that should be displayed at the root level.
 * Typically this will be a header panel, menu panel, page panels, and a footer panel.
 *
 * @author: jesposito
 */

export default function layoutReducer(state = initialState.layout, action: any) {
	switch (action.type) {
		case ActionTypes.LAYOUT_LOAD_SUCCESS:

			// load initial state
			return action.layout;

		case ActionTypes.LAYOUT_PANEL_ADD:

			// insert new panel instance at end of array
			return [...state, action.instance];

		case ActionTypes.LAYOUT_PANEL_REMOVE:

			// remove new panel instance from array
			return state.filter((i) => i !== action.instance);

		case ActionTypes.LAYOUT_SAVE_SUCCESS:

			/** unused, picked up by {@link ajaxStatusReducer */
			return state;

		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./src/core/reducers/layout/layoutReducer.ts